import cssVars from 'css-vars-ponyfill';

cssVars({
  variables: { '--rgb-color': '0, 0, 0' },
  preserveStatic: true,
});
